import React from 'react';

export class MapIframe {

    static post(frame: React.RefObject<HTMLIFrameElement>, message: MapMessage) {
        if (frame && message) {
            frame?.current?.contentWindow?.postMessage(message, '*');
        }
    }

    static generateCartId() {
        return ('S' + Math.random()).replace('.', '');
    }

}


export interface MapMessage {
    type: MapMessageType;
}

export interface GoToMessage extends MapMessage {
    lat: number,
    lng: number,
    closest: boolean
}

export interface GoToGooglePlaceIdMessage extends MapMessage {
    googlePlaceId: string;
}

export interface SegmentIdMessage extends MapMessage {
    segmentId: number;
}

export interface SaveMessage extends MapMessage {
    cartId: string;
}

export interface SegmentIdsMessage extends MapMessage {
    segmentIds: number[];
}

export enum MapMessageType {
    GO_TO = 'goTo',
    GO_TO_GOOGLE_PLACE_ID = 'goToGooglePlaceId',
    TOGGLE_EDITING = 'toggleEditing',
    TOGGLE_SEARCH_BAR = 'toggleSearchBar',
    SELECT_SEGMENT = 'selectSegment',
    REMOVE_FROM_CART = 'removeFromCart',
    ADD_TO_CART = 'addToCart',
    SAVE = 'save',
    RESET = 'reset'
}

export interface BuildingInfo {
    buildingId: string;
    changed?: number;
    lat: number;
    lng: number;
    cartId?: string;
    address?: string;
    totalArea3DM2: number;
    totalProductivityKwhPerYear: number;
    totalInCartArea3DM2: number;
    totalInCartProductivityKwhPerYear: number;
    roofSegments: RoofSegment[];
}

export interface RoofSegment {
    id: number;
    geometry: number[][];
    area3DM2: number;
    area2DM2: number;
    productivityKwhPerYear: number;
    azimuth: number;
    surfacesMinHeight: number;
    buildingHeight: number;
    productivityPerM2: number;
    polyMaxHeight: number;
    surfacesMaxHeight: number;
    tilt: number;
    groundHeight: number;
    inCart: Binary;
    selected: Binary;
    invalid: Binary;
    message: string;
    coordsFlat?: number[][];
}

export type Binary = 0 | 1;

